import api from "app/lib/api";
import endpoints from "static/endpoints";

export const updatePreferences = async (payload) => {
  return await api.put(endpoints.accounts.preferences, payload);
};
